<ng-container [formGroup]="companyForm">
  <!-- Error Message -->
  @if (saveError$ | async; as error) {
    <div class="error-message">
      <p>{{ error }}</p>
    </div>
  }

  <!-- Editable Form Fields -->
  <div class="form-grid">
    <!-- Content projection for readonly fields at the start -->
    <ng-content select="[slot=readonly-fields]"></ng-content>

    <!-- Customer Type -->
    @if (!hideCustomerType) {
      <div class="form-field">
        <label for="customerTypeId">Customer Type</label>
        <select
          id="customerTypeId"
          formControlName="customerTypeId"
          class="form-select">
          <option [ngValue]="null">Select Customer Type</option>
          @for (type of customerTypes$ | async; track type.customerTypeId) {
            <option [ngValue]="type.customerTypeId">
              {{ type.description }}
            </option>
          }
        </select>
      </div>
    }

    <!-- Content projection for additional readonly fields -->
    <ng-content select="[slot=after-customer-type]"></ng-content>

    <!-- Preferred Print Site -->
    <div class="form-field">
      <label for="preferPrintSiteId">Preferred Print Site</label>
      <select
        id="preferPrintSiteId"
        formControlName="preferPrintSiteId"
        class="form-select">
        <option [ngValue]="null">Select Print Site</option>
        @for (site of printSites$ | async; track site.id) {
          <option [ngValue]="site.id">{{ site.printSiteName }}</option>
        }
      </select>
    </div>

    <!-- Check Layout -->
    <div class="form-field">
      <label for="checkLayoutType"
        >Check Layout <span class="required">*</span></label
      >
      <select
        id="checkLayoutType"
        formControlName="checkLayoutType"
        class="form-select">
        <option value="">Select Check Layout</option>
        @for (layout of checkLayoutTypes; track layout.value) {
          <option [value]="layout.value">{{ layout.label }}</option>
        }
      </select>
    </div>
  </div>

  <!-- Checkbox Options -->
  <div class="checkbox-section">
    <h3>Options</h3>
    <div class="checkbox-grid">
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('backOfficeSort')?.value"
            (change)="onNativeCheckboxChange('backOfficeSort', $event)" />
          <span>Back Office Sort</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('packingDetailsDistribution')?.value"
            (change)="
              onNativeCheckboxChange('packingDetailsDistribution', $event)
            " />
          <span>Packing Details Distribution</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('ultibank')?.value"
            (change)="onNativeCheckboxChange('ultibank', $event)" />
          <span>Ultibank</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('custom')?.value"
            (change)="onNativeCheckboxChange('custom', $event)" />
          <span>Custom</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('shippingOverwrite')?.value"
            (change)="onNativeCheckboxChange('shippingOverwrite', $event)" />
          <span>Shipping Overwrite</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('manualCheck')?.value"
            (change)="onNativeCheckboxChange('manualCheck', $event)" />
          <span>Manual Check</span>
        </label>
      </div>
      <div class="checkbox-field">
        <label class="checkbox-label">
          <input
            type="checkbox"
            [checked]="companyForm.get('groupRequests')?.value"
            (change)="onNativeCheckboxChange('groupRequests', $event)" />
          <span>Group Requests</span>
        </label>
      </div>
    </div>
  </div>

  <!-- Custom Process File Name -->
  <div class="form-field full-width">
    <label for="customProcessFileName">Custom Process File Name</label>
    <input
      type="text"
      id="customProcessFileName"
      [value]="companyForm.get('customProcessFileName')?.value || ''"
      (input)="onFieldInput('customProcessFileName', $event)"
      placeholder="Enter Custom Process File Name" />
  </div>

  <!-- Comments -->
  <div class="form-field full-width">
    <label for="comments">Comments</label>
    <textarea
      id="comments"
      [value]="companyForm.get('comments')?.value || ''"
      (input)="onFieldInput('comments', $event)"
      placeholder="Enter any comments..."
      rows="4"></textarea>
  </div>

  <!-- Action Buttons -->
  <div class="form-actions">
    @if (showResetButton) {
      <ukg-button
        variant="tertiary"
        (click)="onReset()"
        (keydown.enter)="onReset()"
        [disabled]="saving$ | async">
        Reset
      </ukg-button>
    }
    <ukg-button
      variant="tertiary"
      (click)="onCancel()"
      (keydown.enter)="onCancel()"
      [disabled]="saving$ | async">
      Cancel
    </ukg-button>
    <ukg-button
      variant="primary"
      (click)="onSave()"
      (keydown.enter)="onSave()"
      [disabled]="(saving$ | async) || companyForm.invalid">
      {{ (saving$ | async) ? savingButtonText : submitButtonText }}
    </ukg-button>
  </div>
</ng-container>
